import { CalendarInterface } from '../interfaces/calendar.interface';
import { FormConfigBase } from './abstract/form-config-base.class';

export class CalendarModel extends FormConfigBase {
  minDate?: Date;
  maxDate?: Date;
  dateFormat?: string;
  readonlyInput?: boolean;
  required?: boolean;
  requiredText?: string;
  placeholder?: string;

  constructor( obj: CalendarInterface ) {
    super( obj );

    this.minDate = obj && obj.minDate ? obj.minDate : null;
    this.maxDate = obj && obj.maxDate ? obj.maxDate : null;
    this.dateFormat = obj && obj.dateFormat ? obj.dateFormat : 'dd/mm/yyyy';
    this.placeholder = obj && obj.placeholder ? obj.placeholder : '';
    this.required = obj && obj.required !== undefined ? obj.required : false;
    this.requiredText = obj && obj.requiredText ? obj.requiredText : '';
    this.readonlyInput = obj && obj.readonlyInput !== undefined ? obj.readonlyInput : false;
  }

  initFullYear( date: Date ): Date {
    let returnV;
    if ( date instanceof Date) {
      returnV = date;
    } else {
      returnV = new Date( date );
    }
    return returnV;
  }
}
